import { useState, useEffect } from "react";
import { StripeElementsOptions, loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import styles from "./Payment.module.css";
import PaymentForm from "./PaymentForm";
import SubscriptionSelect from "./SubscriptionSelect";
import PaymentConfirmation from "./PaymentConfirmation";
import { User } from "types/user";
import { Subscription } from "types/subscription";
import { add, format } from "date-fns";
import { Screens } from "types/general";
interface Props {
	user: User;
	onSuccess: () => void;
	setScreen: (v: Screens) => void;
}
export default function Payment({ user, onSuccess, setScreen }: Props) {
	const [clientSecret, setClientSecret] = useState();
	const [selectedSubscription, setSelectedSubscription] = useState<Subscription>();
	const [paymentSucceeded, setPaymentSucceeded] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState(true);
	const [subscriptions, setSubscriptions] = useState();
	const [apiKey, setApiKey] = useState();
	const [stripePromise, setStripePromise] = useState<any>();

	useEffect(() => {
		// Load the Stripe library once the api key is retrieved
		if (apiKey) {
			setStripePromise(loadStripe(apiKey));
		}
	}, [apiKey]);

	useEffect(() => {
		const getSubscriptions = async () => {
			// await fetch(`${process.env.REACT_APP_STRIPE_URL}/payment/passes`, {
			await fetch(`${process.env.REACT_APP_STRIPE_URL}/payment/passes`, {
				headers: {
					Authorization: user.signInUserSession.idToken.jwtToken,
				},
			})
				.then((response) => {
					if (response.status !== 200) {
						throw new Error();
					} else {
						return response.text();
					}
				})
				.then((res) => {
					const data = JSON.parse(res);
					setApiKey(data.api_key);
					let subscriptions = data.products;
					setSubscriptions(subscriptions);
				})
				.catch((err) => {
					//TODO
				});
			setIsLoading(false);
		};
		getSubscriptions();
	}, [user]);

	let createPaymentIntent = async (sub: Subscription) => {
		// Called in useEffect when subscription is selected.
		// Create payment intent when a subscription (other than "free") is selected.
		if (sub) {
			setIsLoading(true);
			await fetch(`${process.env.REACT_APP_STRIPE_URL}/payment/create`, {
				method: "POST",
				headers: {
					Authorization: user.signInUserSession.idToken.jwtToken,
				},
				body: JSON.stringify({
					paymentType: ["card"],
					description: `MuscoVision Access Pass - Web - ${sub.name}`,

					metadata: {
						userID: user.username,
						userEmail: user.attributes.email,
						passID: sub.passID,
					},
				}),
			})
				.then((res) => res.json())
				.then((data) => {
					setClientSecret(data.client_secret);
				})
				.catch((err) => {
					//TODO
				});
			setIsLoading(false);
		}
	};
	const getPassExpiration = () => {
		let exp = format(add(new Date(), { days: selectedSubscription!.passLength }), "MMMM do yyyy 'at' hh:mma");

		return exp;
	};

	const options: StripeElementsOptions = {
		clientSecret: clientSecret,
		appearance: { theme: "stripe" },
	};

	return (
		<div className={styles.formWrapper}>
			{paymentSucceeded ? (
				<PaymentConfirmation onSuccess={onSuccess} />
			) : (
				<div className={styles.paymentForm}>
					{isLoading ? (
						<div className="d-flex justify-content-center">
							<div className="spinner-border text-primary" role="status">
								<span className="visually-hidden">Loading...</span>
							</div>
						</div>
					) : (
						<>
							{subscriptions ? (
								<SubscriptionSelect
									subscriptions={subscriptions}
									selectedValue={selectedSubscription}
									setSubscription={(sub: any) => {
										setSelectedSubscription(sub);
										createPaymentIntent(sub);
									}}
									setScreen={setScreen}
								/>
							) : null}
							{selectedSubscription ? (
								<p className={styles.subscriptionMessage}>
									<span>NOTE: </span>
									{`This subscription will end on ${getPassExpiration()}.`}
								</p>
							) : null}
							{clientSecret && selectedSubscription ? (
								<Elements options={options} stripe={stripePromise}>
									<PaymentForm setPaymentSucceeded={() => setPaymentSucceeded(true)} clientSecret={clientSecret} />
								</Elements>
							) : null}
						</>
					)}
				</div>
			)}
		</div>
	);
}
